module.exports = __webpack_public_path__ + "img/every-student.350e57e.png";